import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== "NavigationDuplicated") throw err;
  });
};

// Layout
import UnAuthLayout from "../views/layouts/unauth-layout.vue";
import AuthLayout from "../views/layouts/auth-layout.vue";

// Static
import HomePage from "../views/home/index.vue";
import SellerHomePage from "../views/seller-home/index.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import SmsTestPage from "../views/sms-test/index.vue";
import CreateAdminPage from "../views/users/create-admin.vue";
import AdminListPage from "../views/admins/index.vue";

// Auth
import LoginPage from "../views/auth/login.vue";
import SellerLoginPage from "../views/auth/seller-login.vue";
import ForgotPasswordPage from "../views/auth/forgot-password.vue";

// Companies
import CompaniesPage from "../views/companies/index.vue";
import CompanyCreatePage from "../views/companies/create.vue";
import CompanyIdPage from "../views/companies/id.vue";

// Users
import UsersPage from "../views/users/index.vue";
import UserCreatePage from "../views/users/create.vue";
import DoctorCreatePage from "../views/users/create-doctor.vue";
import DoctorEditPage from "../views/users/edit-doctor.vue";
import PatientCreatePage from "../views/users/create-patient.vue";
import PatientEditPage from "../views/users/edit-patient.vue";
import CustomerCreatePage from "../views/users/create-customer.vue";
import CustomerEditPage from "../views/users/edit-customer.vue";
import SellerCreatePage from "../views/sellers/create.vue";
import SellerEditPage from "../views/sellers/id.vue";
import SellerDetailPage from "../views/sellers/detail.vue";
import UserIdPage from "../views/users/id.vue";
import ProfilePage from "../views/users/id.vue";
import UsersUploadPage from "../views/users/upload.vue";
import UserDocumentsPage from "../views/users/documents.vue";
import UserDocumentCreatePage from "../views/user_documents/create.vue";
import DoctorsPage from "../views/users/doctors.vue";
import DoctorDetailPage from "../views/doctors/detail.vue";
import PatientsPage from "../views/users/patients.vue";
import BlockedDoctorsPage from "../views/blocked-doctors/index.vue";
import PatientReferralsPage from "../views/patient-referrals/index.vue";
import CustomersPage from "../views/users/customers.vue";
import SellersPage from "../views/users/sellers.vue";

// Doctor Specialities
import DoctorSpecialitiesPage from "../views/doctor_specialities/index.vue";
import DoctorSpecialityCreatePage from "../views/doctor_specialities/create.vue";
import DoctorSpecialityIdPage from "../views/doctor_specialities/id.vue";

// Doctor Available Days
import DoctorAvailableDaysPage from "../views/doctor-available-days/index.vue";
import DoctorAvailableDayCreatePage from "../views/doctor-available-days/create.vue";
import DoctorAvailableDayIdPage from "../views/doctor-available-days/id.vue";

// Positions
import PositionsPage from "../views/positions/index.vue";
import PositionCreatePage from "../views/positions/create.vue";
import PositionIdPage from "../views/positions/id.vue";

// Roles
import RolesPage from "../views/roles/index.vue";
import RoleIdPage from "../views/roles/id.vue";

// Modules
import ModulesPage from "../views/modules/index.vue";
import ModuleCreatePage from "../views/modules/create.vue";
import ModuleIdPage from "../views/modules/id.vue";


// Permissions
import PermissionsPage from "../views/permissions/index.vue";
import PermissionCreatePage from "../views/permissions/create.vue";
import PermissionIdPage from "../views/permissions/id.vue";

// Penalties
import PenaltiesPage from "../views/penalties/index.vue";
import PenaltyCreatePage from "../views/penalties/create.vue";
import PenaltyIdPage from "../views/penalties/id.vue";

// Payouts
import PayoutsPage from "../views/payouts/index.vue";
import PayoutCreatePage from "../views/payouts/create.vue";
import PayoutIdPage from "../views/payouts/id.vue";

// Values
import Values from "@/views/values/index.vue";
import ValueCreate from "@/views/values/create.vue";
import ValueId from "@/views/values/id.vue";

// ValueLists
import ValueLists from "@/views/value-lists/index.vue";
import ValueListUpload from "@/views/value-lists/upload.vue";
import ValueListCreate from "@/views/value-lists/create.vue";
import ValueListId from "@/views/value-lists/id.vue";

// Products
import ProductsPage from "@/views/products/index.vue";
import ProductCreatePage from "@/views/products/create.vue";
import ProductIdPage from "@/views/products/id.vue";
import ProductUploadPage from "@/views/products/upload.vue";
import ProductUploadHistoryPage from "@/views/products/upload-history.vue";
import ProductApprovalPage from "@/views/products/approval.vue";

// Products
import ProductVariantsPage from "@/views/product-variants/index.vue";
import ProductVariantCreatePage from "@/views/product-variants/create.vue";
import ProductVariantIdPage from "@/views/product-variants/id.vue";
import ProductQuestionsPage from "@/views/product-questions/index.vue";
import ProductReviewsPage from "@/views/product-reviews/index.vue";
// import ProductVariantUploadPage from "@/views/product-variants/upload.vue";
// import ProductVariantUploadHistoryPage from "@/views/product-variants/upload-history.vue";
// import ProductVariantApprovalPage from "@/views/product-variants/approval.vue";

// Delivery Partners
import DeliveryPartnersPage from "@/views/delivery-partners/index.vue";
import DeliveryPartnerCreatePage from "@/views/delivery-partners/create.vue";
import DeliveryPartnerIdPage from "@/views/delivery-partners/id.vue";

// Deliveries
import DeliveriesPage from "@/views/deliveries/index.vue";

// Tags
import TagsPage from "@/views/tags/index.vue";
import TagCreatePage from "@/views/tags/create.vue";
import TagIdPage from "@/views/tags/id.vue";

// Coupons
import CouponsPage from "@/views/coupons/index.vue";
import CouponCreatePage from "@/views/coupons/create.vue";
import CouponIdPage from "@/views/coupons/id.vue";
import CouponUsageReport from "@/views/coupons/usage-report.vue";

// Categories
import CategoriesPage from "@/views/categories/index.vue";
import CategoryCreatePage from "@/views/categories/create.vue";
import CategoryIdPage from "@/views/categories/id.vue";

// HSN Masters
import HsnMastersPage from "@/views/hsn-masters/index.vue";
import HsnMasterCreatePage from "@/views/hsn-masters/create.vue";
import HsnMasterIdPage from "@/views/hsn-masters/id.vue";

// Orders
import OrdersPage from "@/views/orders/index.vue";
import OrderCreatePage from "@/views/orders/create.vue";
import OrderIdPage from "@/views/orders/id.vue";
import OrderItemsViewPage from "@/views/orders/items.vue";

// Order Items
import OrderItemsPage from "@/views/order-items/index.vue";
import OrderItemCreatePage from "@/views/order-items/create.vue";
import OrderItemIdPage from "@/views/order-items/id.vue";

// OTP Logs
import OtpLogsPage from "@/views/otp-logs/index.vue";

// Appointments
import AppointmentsPage from "@/views/appointments/index.vue";
import AppointmentCreatePage from "@/views/appointments/create.vue";
import AppointmentIdPage from "@/views/appointments/id.vue";

// Consultations
import ConsultationsPage from "@/views/consultations/index.vue";
import ConsultationCreatePage from "@/views/consultations/create.vue";
import ConsultationIdPage from "@/views/consultations/id.vue";

// Prescriptions
import PrescriptionsPage from "@/views/prescriptions/index.vue";
import PrescriptionCreatePage from "@/views/prescriptions/create.vue";
import PrescriptionIdPage from "@/views/prescriptions/id.vue";
import PrescriptionDetailPage from "@/views/prescriptions/detail.vue";

// Prescription Items
import PrescriptionItemsPage from "@/views/prescription-items/index.vue";
import PrescriptionItemCreatePage from "@/views/prescription-items/create.vue";
import PrescriptionItemIdPage from "@/views/prescription-items/id.vue";

// Chats
import ChatsPage from "@/views/chats/index.vue";
import ChatCreatePage from "@/views/chats/create.vue";
import ChatIdPage from "@/views/chats/id.vue";

// Chat Messages
import ChatMessagesPage from "@/views/chat-messages/index.vue";
import ChatMessageCreatePage from "@/views/chat-messages/create.vue";
import ChatMessageIdPage from "@/views/chat-messages/id.vue";
import ChatInterface from "@/views/chat-messages/chat.vue";

// WebSocket Test
import WebSocketTest from "@/views/WebSocketTest.vue";
import ComprehensiveWebSocketTest from "@/views/ComprehensiveWebSocketTest.vue";

// Billing System Test
import BillingSystemTest from "@/components/BillingSystemTest.vue";

// Billing Debug Console
import BillingDebug from "@/views/billing-debug/index.vue";

// Transactions
import TransactionsPage from "@/views/transactions/index.vue";
import TransactionCreatePage from "@/views/transactions/create.vue";
import TransactionIdPage from "@/views/transactions/id.vue";
// Reports
import TransactionAuditReportPage from "@/views/reports/transaction-audit.vue";

// Announcements
import AnnouncementsPage from "@/views/announcements/index.vue";
import AnnouncementCreatePage from "@/views/announcements/create.vue";
import AnnouncementIdPage from "@/views/announcements/id.vue";
// Daily Tips
import DailyTipsPage from "@/views/daily-tips/index.vue";
import DailyTipCreatePage from "@/views/daily-tips/create.vue";
import DailyTipIdPage from "@/views/daily-tips/id.vue";

// Raise Tickets
import RaiseTicketsPage from "@/views/raise-tickets/index.vue";
import RaiseTicketIdPage from "@/views/raise-tickets/id.vue";

// Notifications
import NotificationsPage from "@/views/notifications/index.vue";
import NotificationCreatePage from "@/views/notifications/create.vue";
import NotificationIdPage from "@/views/notifications/id.vue";

// Bank Details
import BankDetailsPage from "@/views/bank-details/index.vue";
import BankDetailCreatePage from "@/views/bank-details/create.vue";
import BankDetailIdPage from "@/views/bank-details/id.vue";
import BankDetailsApprovalPage from "@/views/bank-details/approval.vue";

// Education Details
import EducationDetailsPage from "@/views/education_details/index.vue";
import EducationDetailCreatePage from "@/views/education_details/create.vue";
import EducationDetailIdPage from "@/views/education_details/id.vue";
import EducationApprovalPage from "@/views/education_details/approval.vue";

// Council Registration Certificates
import CouncilRegistrationCertificatesPage from "@/views/council_registration_certificates/index.vue";
import CouncilRegistrationCertificateCreatePage from "@/views/council_registration_certificates/create.vue";
import CouncilRegistrationCertificateIdPage from "@/views/council_registration_certificates/id.vue";
import CouncilCertificateApprovalPage from "@/views/council_registration_certificates/approval.vue";

// Seller Products
import SellerProductsPage from "@/views/seller-products/index.vue";
import SellerProductCreatePage from "@/views/seller-products/create.vue";
import SellerProductIdPage from "@/views/seller-products/id.vue";

// Seller Product Variants
import SellerProductVariantsPage from "@/views/seller-product-variants/index.vue";
import SellerProductVariantCreatePage from "@/views/seller-product-variants/create.vue";
import SellerProductVariantIdPage from "@/views/seller-product-variants/id.vue";
import SellerProductVariantMapperPage from "@/views/seller-product-variants/mapper.vue";
import SellerProductVariantUploadPage from "@/views/seller-product-variants/upload.vue";

// Work Histories
import WorkHistoriesPage from "@/views/work_histories/index.vue";
import WorkHistoryCreatePage from "@/views/work_histories/create.vue";
import WorkHistoryIdPage from "@/views/work_histories/id.vue";

// Awards
import AwardsPage from "@/views/awards/index.vue";
import AwardCreatePage from "@/views/awards/create.vue";
import AwardIdPage from "@/views/awards/id.vue";

// Memberships
import MembershipsPage from "@/views/memberships/index.vue";
import MembershipCreatePage from "@/views/memberships/create.vue";
import MembershipIdPage from "@/views/memberships/id.vue";

// Languages
import LanguagesPage from "@/views/languages/index.vue";
import LanguageCreatePage from "@/views/languages/create.vue";
import LanguageIdPage from "@/views/languages/id.vue";

// Account Delete Requests
import AccountDeleteRequestsPage from "@/views/account-delete-requests/index.vue";
import AccountDeleteRequestCreatePage from "@/views/account-delete-requests/create.vue";
import AccountDeleteRequestIdPage from "@/views/account-delete-requests/id.vue";

const routes = [
  // Root redirect
  {
    path: "/",
    redirect: () => {
      const hostname = window.location.hostname;
      if (hostname.startsWith('seller.')) {
        return '/seller-home';
      }
      return '/home';
    }
  },
  // Standalone Routes (No Layout - No Sidebar/Navbar)
  // IMPORTANT: These must come BEFORE AuthLayout to match correctly
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
    meta: { allowPublic: true } // Accessible for both auth and unauth users
  },
  {
    path: "/account-delete-requests/create",
    name: "account-delete-requests-create",
    component: AccountDeleteRequestCreatePage,
    meta: { allowPublic: true } // Accessible for both auth and unauth users
  },
  // AuthLayout
  {
    path: "/auth",
    name: "AuthLayout",
    component: AuthLayout,
    children: [
      {
        path: "/home",
        name: "HomePage",
        component: HomePage,
      },
      {
        path: "/seller-home",
        name: "SellerHomePage",
        component: SellerHomePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/sms-test",
        name: "SmsTestPage",
        component: SmsTestPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/admins",
        name: "AdminListPage",
        component: AdminListPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/users/create-admin",
        name: "CreateAdminPage",
        component: CreateAdminPage,
        meta: { requiresAuth: true }
      },
      // Companies
      {
        path: "/companies",
        name: "CompaniesPage",
        component: CompaniesPage,
        meta: { permission: "COMPANIES.VIEW" }
      },
      {
        path: "/companies/create",
        name: "CompanyCreatePage",
        component: CompanyCreatePage,
        meta: { permission: "COMPANIES.CREATE" }
      },
      {
        path: "/companies/:companyId",
        name: "CompanyIdPage",
        component: CompanyIdPage,
        meta: { permissions: ["COMPANIES.UPDATE", "COMPANIES.SINGLE_VIEW"] }
      },
      // Users
      {
        path: "/users",
        name: "UsersPage",
        component: UsersPage,
        meta: { permission: "USERS.VIEW" }
      },
      {
        path: "/users/create",
        name: "UserCreatePage",
        component: UserCreatePage,
        meta: { permission: "USERS.CREATE" }
      },
      {
        path: "/doctor/create",
        name: "DoctorCreatePage",
        component: DoctorCreatePage,
        meta: { requiresAuth: true },
      },
      {
        path: "/doctor/:id",
        name: "DoctorEditPage",
        component: DoctorEditPage,
        meta: { requiresAuth: true },
      },
      {
        path: "/patient/create",
        name: "PatientCreatePage",
        component: PatientCreatePage,
        meta: { requiresAuth: true },
      },
      {
        path: "/customer/create",
        name: "CustomerCreatePage",
        component: CustomerCreatePage,
        meta: { requiresAuth: true },
      },
      {
        path: "/patient/:id",
        name: "PatientEditPage",
        component: PatientEditPage,
        meta: { requiresAuth: true },
      },
      {
        path: "/customer/:id",
        name: "CustomerEditPage",
        component: CustomerEditPage,
        meta: { requiresAuth: true },
      },
      {
        path: "/sellers/create",
        name: "SellerCreatePage",
        component: SellerCreatePage,
        meta: { requiresAuth: true },
      },
      {
        path: "/sellers/:id/details",
        name: "SellerDetailPage",
        component: SellerDetailPage,
        meta: { requiresAuth: true },
      },
      {
        path: "/sellers/:id",
        name: "SellerEditPage",
        component: SellerEditPage,
        meta: { requiresAuth: true },
      },
      {
        path: "/users/upload",
        name: "UsersUploadPage",
        component: UsersUploadPage,
        meta: { permission: "USERS.CREATE" }
      },
      // Position-based User Pages
      {
        path: "/doctors",
        name: "DoctorsPage",
        component: DoctorsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/patients",
        name: "PatientsPage",
        component: PatientsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/patients/:id/blocked-doctors",
        name: "BlockedDoctorsPage",
        component: BlockedDoctorsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/patients/:id/referrals",
        name: "PatientReferralsPage",
        component: PatientReferralsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/customers",
        name: "CustomersPage",
        component: CustomersPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/sellers",
        name: "SellersPage",
        component: SellersPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/profile/:userId",
        name: "ProfilePage",
        component: ProfilePage,
      },
      {
        path: "/users/:userId",
        name: "UserIdPage",
        component: UserIdPage,
        meta: { permissions: ["USERS.UPDATE", "USERS.SINGLE_VIEW"] }
      },
      {
        path: "/users/:userId/documents",
        name: "UserDocumentsPage",
        component: UserDocumentsPage,
      },

      // Doctor Specialities
      {
        path: "/doctor_specialities",
        name: "DoctorSpecialitiesPage",
        component: DoctorSpecialitiesPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctor_specialities/create",
        name: "DoctorSpecialityCreatePage",
        component: DoctorSpecialityCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctor_specialities/:id",
        name: "DoctorSpecialityIdPage",
        component: DoctorSpecialityIdPage,
        meta: { requiresAuth: true }
      },

      // Doctor Available Days
      {
        path: "/doctor-available-days",
        name: "DoctorAvailableDaysPage",
        component: DoctorAvailableDaysPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctor-available-days/create",
        name: "DoctorAvailableDayCreatePage",
        component: DoctorAvailableDayCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctor-available-days/:id",
        name: "DoctorAvailableDayIdPage",
        component: DoctorAvailableDayIdPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctor-available-days/:id/edit",
        name: "DoctorAvailableDayEditPage",
        component: DoctorAvailableDayIdPage,
        meta: { requiresAuth: true }
      },

      // Positions
      {
        path: "/positions",
        name: "PositionsPage",
        component: PositionsPage,
        meta: { permission: "POSITIONS.VIEW" }
      },
      {
        path: "/positions/create",
        name: "PositionCreatePage",
        component: PositionCreatePage,
        meta: { permission: "POSITIONS.CREATE" }
      },
      {
        path: "/positions/:positionId",
        name: "PositionIdPage",
        component: PositionIdPage,
        meta: { permissions: ["POSITIONS.UPDATE", "POSITIONS.SINGLE_VIEW"] }
      },
      // Roles
      {
        path: "/roles",
        name: "RolesPage",
        component: RolesPage,
        meta: { permission: "ROLES.VIEW" }
      },
      {
        path: "/roles/:roleId",
        name: "RoleIdPage",
        component: RoleIdPage,
        meta: { permissions: ["ROLES.UPDATE", "ROLES.SINGLE_VIEW"] }
      },
      // Modules
      {
        path: "/modules",
        name: "ModulesPage",
        component: ModulesPage,
        meta: { permission: "MODULES.VIEW" }
      },
      {
        path: "/modules/create",
        name: "ModuleCreatePage",
        component: ModuleCreatePage,
        meta: { permission: "MODULES.CREATE" }
      },
      {
        path: "/modules/:moduleId",
        name: "ModuleIdPage",
        component: ModuleIdPage,
        meta: { permissions: ["MODULES.UPDATE", "MODULES.SINGLE_VIEW"] }
      },
      // Permissions
      {
        path: "/permissions",
        name: "PermissionsPage",
        component: PermissionsPage,
        meta: { permission: "PERMISSIONS.VIEW" }
      },
      {
        path: "/permissions/create",
        name: "PermissionCreatePage",
        component: PermissionCreatePage,
        meta: { permission: "PERMISSIONS.CREATE" }
      },
      {
        path: "/permissions/:permissionId",
        name: "PermissionIdPage",
        component: PermissionIdPage,
        meta: { permissions: ["PERMISSIONS.UPDATE", "PERMISSIONS.SINGLE_VIEW"] }
      },
      // Penalties
      {
        path: "/penalties",
        name: "penalties",
        component: PenaltiesPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/penalties/deleted",
        name: "penalties-deleted",
        component: PenaltiesPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/penalties/create",
        name: "penalties-create",
        component: PenaltyCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/penalties/:id",
        name: "penalties-edit",
        component: PenaltyIdPage,
        meta: { requiresAuth: true }
      },
      // Payouts
      {
        path: "/payouts",
        name: "payouts",
        component: PayoutsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/payouts/deleted",
        name: "payouts-deleted",
        component: PayoutsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/payouts/create",
        name: "payouts-create",
        component: PayoutCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/payouts/:id",
        name: "payouts-edit",
        component: PayoutIdPage,
        meta: { requiresAuth: true }
      },
      // Values
      {
        path: "/values",
        name: "Values",
        component: Values,
      },
      {
        path: "/values/create",
        name: "ValueCreate",
        component: ValueCreate,
      },
      {
        path: "/values/:valueId",
        name: "ValueId",
        component: ValueId,
      },
      // ValueLists
      {
        path: "/value-lists",
        name: "ValueLists",
        component: ValueLists,
      },
      {
        path: "/value-lists/upload",
        name: "ValueListUpload",
        component: ValueListUpload,
      },
      {
        path: "/value-lists/create",
        name: "ValueListCreate",
        component: ValueListCreate,
      },
      {
        path: "/value-lists/:valueListId",
        name: "ValueListId",
        component: ValueListId,
      },
      // Products
      {
        path: "/products",
        name: "ProductsPage",
        component: ProductsPage,
        meta: { permission: "PRODUCTS.VIEW" }
      },
      {
        path: "/products/create",
        name: "ProductCreatePage",
        component: ProductCreatePage,
        meta: { permission: "PRODUCTS.CREATE" }
      },
      {
        path: "/products/upload",
        name: "ProductUploadPage",
        component: ProductUploadPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/products/upload-history",
        name: "ProductUploadHistoryPage",
        component: ProductUploadHistoryPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/products/approvals",
        name: "ProductApprovalPage",
        component: ProductApprovalPage,
        meta: { permission: "PRODUCTS.VIEW" }
      },
      {
        path: "/products/:id",
        name: "ProductIdPage",
        component: ProductIdPage,
        meta: { permissions: ["PRODUCTS.UPDATE", "PRODUCTS.SINGLE_VIEW"] }
      },
      {
        path: "/delivery-partners",
        name: "DeliveryPartnersPage",
        component: DeliveryPartnersPage,
        meta: { permissions: ["DELIVERY_PARTNERS.VIEW"] }
      },
      {
        path: "/delivery-partners/create",
        name: "DeliveryPartnerCreatePage",
        component: DeliveryPartnerCreatePage,
        meta: { permissions: ["DELIVERY_PARTNERS.CREATE"] }
      },
      {
        path: "/delivery-partners/:id",
        name: "DeliveryPartnerIdPage",
        component: DeliveryPartnerIdPage,
        meta: { permissions: ["DELIVERY_PARTNERS.UPDATE", "DELIVERY_PARTNERS.SINGLE_VIEW"] }
      },
      {
        path: "/deliveries",
        name: "DeliveriesPage",
        component: DeliveriesPage,
        meta: { permissions: ["DELIVERY_PARTNERS.VIEW"] }
      },
      // ProductVariants
      {
        path: "/products/:productId/product-variants",
        name: "ProductVariantsPage",
        component: ProductVariantsPage,
      },
      {
        path: "/products/:productId/product-variants/create",
        name: "ProductVariantCreatePage",
        component: ProductVariantCreatePage,
      },
      // {
      //   path: "/products/:productId/product-variants/upload",
      //   name: "ProductVariantUploadPage",
      //   component: ProductVariantUploadPage,
      //   meta: { requiresAuth: true }
      // },
      // {
      //   path: "/products/:productId/product-variants/upload-history",
      //   name: "ProductVariantUploadHistoryPage",
      //   component: ProductVariantUploadHistoryPage,
      //   meta: { requiresAuth: true }
      // },
      // {
      //   path: "/products/:productId/product-variants/approvals",
      //   name: "ProductVariantApprovalPage",
      //   component: ProductVariantApprovalPage,
      //   meta: { requiresAuth: true }
      // },
      {
        path: "/products/:productId/product-variants/:productVariantId",
        name: "ProductVariantIdPage",
        component: ProductVariantIdPage,
      },
      {
        path: "/products/:productId/product-variants/:productVariantId/questions",
        name: "ProductQuestionsPage",
        component: ProductQuestionsPage,
      },
      {
        path: "/products/:productId/product-variants/:productVariantId/reviews",
        name: "ProductReviewsPage",
        component: ProductReviewsPage,
      },
      // Seller Products
      {
        path: "/seller-products",
        name: "SellerProductsPage",
        component: SellerProductsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/seller-products/create",
        name: "SellerProductCreatePage",
        component: SellerProductCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/seller-products/:sellerProductId",
        name: "SellerProductIdPage",
        component: SellerProductIdPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/seller-products/:sellerProductId/product-variants",
        name: "SellerProductVariantsForProductPage",
        component: SellerProductVariantsPage,
        meta: { requiresAuth: true }
      },
      // Seller Product Variants
      {
        path: "/seller-product-variants",
        name: "SellerProductVariantsPage",
        component: SellerProductVariantsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/seller-product-variants/create",
        name: "SellerProductVariantCreatePage",
        component: SellerProductVariantCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/seller-product-variants/mapper",
        name: "SellerProductVariantMapperPage",
        component: SellerProductVariantMapperPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/seller-product-variants/upload",
        name: "SellerProductVariantUploadPage",
        component: SellerProductVariantUploadPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/seller-product-variants/:id",
        name: "SellerProductVariantIdPage",
        component: SellerProductVariantIdPage,
        meta: { requiresAuth: true }
      },
      // Tags
      {
        path: "/tags",
        name: "TagsPage",
        component: TagsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/tags/create",
        name: "TagCreatePage",
        component: TagCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/tags/:id",
        name: "TagIdPage",
        component: TagIdPage,
        meta: { requiresAuth: true }
      },
      // Coupons
      {
        path: "/coupons",
        name: "CouponsPage",
        component: CouponsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/coupons/create",
        name: "CouponCreatePage",
        component: CouponCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/coupons/usage-report",
        name: "CouponUsageReport",
        component: CouponUsageReport,
        meta: { requiresAuth: true }
      },
      {
        path: "/coupons/:id",
        name: "CouponIdPage",
        component: CouponIdPage,
        meta: { requiresAuth: true }
      },
      // Categories
      {
        path: "/categories",
        name: "CategoriesPage",
        component: CategoriesPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/categories/create",
        name: "CategoryCreatePage",
        component: CategoryCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/categories/:id",
        name: "CategoryIdPage",
        component: CategoryIdPage,
        meta: { requiresAuth: true }
      },
      // HSN Masters
      {
        path: "/hsn-masters",
        name: "HsnMastersPage",
        component: HsnMastersPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/hsn-masters/create",
        name: "HsnMasterCreatePage",
        component: HsnMasterCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/hsn-masters/:id",
        name: "HsnMasterIdPage",
        component: HsnMasterIdPage,
        meta: { requiresAuth: true }
      },
      // Orders
      {
        path: "/orders",
        name: "OrdersPage",
        component: OrdersPage,
        meta: { permission: "ORDERS.VIEW" }
      },
      {
        path: "/orders/create",
        name: "OrderCreatePage",
        component: OrderCreatePage,
        meta: { permission: "ORDERS.CREATE" }
      },
      {
        path: "/orders/:orderId",
        name: "OrderIdPage",
        component: OrderIdPage,
        meta: { permissions: ["ORDERS.UPDATE", "ORDERS.SINGLE_VIEW"] }
      },
      {
        path: "/orders/:orderId/items",
        name: "OrderItemsViewPage",
        component: OrderItemsViewPage,
        meta: { requiresAuth: true }
      },
      // Order Items
      {
        path: "/order-items",
        name: "OrderItemsPage",
        component: OrderItemsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/order-items/create",
        name: "OrderItemCreatePage",
        component: OrderItemCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/order-items/:orderItemId",
        name: "OrderItemIdPage",
        component: OrderItemIdPage,
        meta: { requiresAuth: true }
      },
      // OTP Logs
        {
          path: "/otp-logs",
          name: "OtpLogsPage",
          component: OtpLogsPage,
          meta: { permission: "USERS.VIEW" }
        },

      // Appointments
      {
        path: "/appointments",
        name: "AppointmentsPage",
        component: AppointmentsPage,
        meta: { permission: "APPOINTMENTS.VIEW" }
      },
      {
        path: "/appointments/create",
        name: "AppointmentCreatePage",
        component: AppointmentCreatePage,
        meta: { permission: "APPOINTMENTS.CREATE" }
      },
      {
        path: "/appointments/:appointmentId",
        name: "AppointmentIdPage",
        component: AppointmentIdPage,
        meta: { permissions: ["APPOINTMENTS.UPDATE", "APPOINTMENTS.SINGLE_VIEW"] }
      },
      // Consultations
      {
        path: "/consultations",
        name: "ConsultationsPage",
        component: ConsultationsPage,
        meta: { permission: "CONSULTATIONS.VIEW" }
      },
      {
        path: "/consultations/create",
        name: "ConsultationCreatePage",
        component: ConsultationCreatePage,
        meta: { permission: "CONSULTATIONS.CREATE" }
      },
      {
        path: "/consultations/:id",
        name: "ConsultationIdPage",
        component: ConsultationIdPage,
        meta: { permissions: ["CONSULTATIONS.UPDATE", "CONSULTATIONS.SINGLE_VIEW"] }
      },
      // Prescriptions
      {
        path: "/prescriptions",
        name: "PrescriptionsPage",
        component: PrescriptionsPage,
        meta: { permission: "PRESCRIPTIONS.VIEW" }
      },
      {
        path: "/prescriptions/create",
        name: "PrescriptionCreatePage",
        component: PrescriptionCreatePage,
        meta: { permission: "PRESCRIPTIONS.CREATE" }
      },
      {
        path: "/prescriptions/:id",
        name: "PrescriptionIdPage",
        component: PrescriptionIdPage,
        meta: { permissions: ["PRESCRIPTIONS.UPDATE", "PRESCRIPTIONS.SINGLE_VIEW"] }
      },
      {
        path: "/prescriptions/:id/details",
        name: "PrescriptionDetailPage",
        component: PrescriptionDetailPage,
        meta: { permissions: ["PRESCRIPTIONS.SINGLE_VIEW"] }
      },
      // Prescription Items
      {
        path: "/prescription-items",
        name: "PrescriptionItemsPage",
        component: PrescriptionItemsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/prescription-items/create",
        name: "PrescriptionItemCreatePage",
        component: PrescriptionItemCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/prescription-items/:id",
        name: "PrescriptionItemIdPage",
        component: PrescriptionItemIdPage,
        meta: { requiresAuth: true }
      },
      // Chats
      {
        path: "/chats",
        name: "ChatsPage",
        component: ChatsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/chats/create",
        name: "ChatCreatePage",
        component: ChatCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/chats/:id",
        name: "ChatIdPage",
        component: ChatIdPage,
        meta: { requiresAuth: true }
      },
      // Chat Messages
      {
        path: "/chat-messages",
        name: "ChatMessagesPage",
        component: ChatMessagesPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/chat-messages/create",
        name: "ChatMessageCreatePage",
        component: ChatMessageCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/chat-messages/:id",
        name: "ChatMessageIdPage",
        component: ChatMessageIdPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/chat",
        name: "ChatInterface",
        component: ChatInterface,
        meta: { requiresAuth: true }
      },
      {
        path: "/chat/:chatId",
        name: "ChatInterfaceWithId",
        component: ChatInterface,
        meta: { requiresAuth: true }
      },
      {
        path: "/websocket-test",
        name: "WebSocketTest",
        component: WebSocketTest,
        meta: { requiresAuth: true }
      },
      {
        path: "/websocket-test-comprehensive",
        name: "ComprehensiveWebSocketTest",
        component: ComprehensiveWebSocketTest,
        meta: { requiresAuth: true }
      },
      {
        path: "/billing-test",
        name: "BillingSystemTest",
        component: BillingSystemTest,
        meta: { requiresAuth: true }
      },
      {
        path: "/billing-debug",
        name: "BillingDebug",
        component: BillingDebug,
        meta: { requiresAuth: true }
      },
      // Reports — Transaction Audit
      {
        path: "/reports/transaction-audit",
        name: "TransactionAuditReportPage",
        component: TransactionAuditReportPage,
        meta: { requiresAuth: true }
      },
      // Transactions
      {
        path: "/transactions",
        name: "TransactionsPage",
        component: TransactionsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/transactions/create",
        name: "TransactionCreatePage",
        component: TransactionCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/transactions/:transactionId",
        name: "TransactionIdPage",
        component: TransactionIdPage,
        meta: { requiresAuth: true }
      },
      // Announcements
      {
        path: "/announcements",
        name: "AnnouncementsPage",
        component: AnnouncementsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/announcements/create",
        name: "AnnouncementCreatePage",
        component: AnnouncementCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/announcements/:id",
        name: "AnnouncementIdPage",
        component: AnnouncementIdPage,
        meta: { requiresAuth: true }
      },
      // Daily Tips
      {
        path: "/daily-tips",
        name: "DailyTipsPage",
        component: DailyTipsPage,
        meta: { requiresAuth: true, permission: "DAILY_TIPS.VIEW" }
      },
      {
        path: "/daily-tips/create",
        name: "DailyTipCreatePage",
        component: DailyTipCreatePage,
        meta: { requiresAuth: true, permission: "DAILY_TIPS.CREATE" }
      },
      {
        path: "/daily-tips/:id",
        name: "DailyTipIdPage",
        component: DailyTipIdPage,
        meta: { requiresAuth: true, permission: "DAILY_TIPS.UPDATE" }
      },
      // Raise Tickets
      {
        path: "/raise-tickets",
        name: "RaiseTicketsPage",
        component: RaiseTicketsPage,
        meta: { requiresAuth: true, permission: "RAISE_TICKETS.VIEW" }
      },
      {
        path: "/raise-tickets/:id",
        name: "RaiseTicketIdPage",
        component: RaiseTicketIdPage,
        meta: { requiresAuth: true, permission: "RAISE_TICKETS.SINGLE_VIEW" }
      },
      // Notifications
      {
        path: "/notifications",
        name: "NotificationsPage",
        component: NotificationsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/notifications/create",
        name: "NotificationCreatePage",
        component: NotificationCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/notifications/:id",
        name: "NotificationIdPage",
        component: NotificationIdPage,
        meta: { requiresAuth: true }
      },
      // Bank Details
      {
        path: "/bank-details",
        name: "BankDetailsPage",
        component: BankDetailsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/bank-details/create",
        name: "BankDetailCreatePage",
        component: BankDetailCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/bank-details/approvals",
        name: "BankDetailsApprovalPage",
        component: BankDetailsApprovalPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/bank-details/:id",
        name: "BankDetailIdPage",
        component: BankDetailIdPage,
        meta: { requiresAuth: true }
      },
      // Education Details
      {
        path: "/education_details",
        name: "EducationDetailsPage",
        component: EducationDetailsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/education_details/create",
        name: "EducationDetailCreatePage",
        component: EducationDetailCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/education_details/approvals",
        name: "EducationApprovalPage",
        component: EducationApprovalPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/education_details/:id",
        name: "EducationDetailIdPage",
        component: EducationDetailIdPage,
        meta: { requiresAuth: true }
      },

      // Council Registration Certificates
      {
        path: "/council_registration_certificates",
        name: "CouncilRegistrationCertificatesPage",
        component: CouncilRegistrationCertificatesPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/council_registration_certificates/create",
        name: "CouncilRegistrationCertificateCreatePage",
        component: CouncilRegistrationCertificateCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/council_registration_certificates/approval",
        name: "CouncilCertificateApprovalPage",
        component: CouncilCertificateApprovalPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/council_registration_certificates/:id",
        name: "CouncilRegistrationCertificateIdPage",
        component: CouncilRegistrationCertificateIdPage,
        meta: { requiresAuth: true }
      },

      // Work Histories
      {
        path: "/work_histories",
        name: "WorkHistoriesPage",
        component: WorkHistoriesPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/work_histories/create",
        name: "WorkHistoryCreatePage",
        component: WorkHistoryCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/work_histories/:id",
        name: "WorkHistoryIdPage",
        component: WorkHistoryIdPage,
        meta: { requiresAuth: true }
      },

      // Awards
      {
        path: "/awards",
        name: "AwardsPage",
        component: AwardsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/awards/create",
        name: "AwardCreatePage",
        component: AwardCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/awards/:id",
        name: "AwardIdPage",
        component: AwardIdPage,
        meta: { requiresAuth: true }
      },

      // Memberships
      {
        path: "/memberships",
        name: "MembershipsPage",
        component: MembershipsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/memberships/create",
        name: "MembershipCreatePage",
        component: MembershipCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/memberships/:id",
        name: "MembershipIdPage",
        component: MembershipIdPage,
        meta: { requiresAuth: true }
      },

      // Languages
      {
        path: "/languages",
        name: "languages",
        component: LanguagesPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/languages/create",
        name: "languages-create",
        component: LanguageCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/languages/:id",
        name: "languages-edit",
        component: LanguageIdPage,
        meta: { requiresAuth: true }
      },
      // Account Delete Requests
      {
        path: "/account-delete-requests",
        name: "account-delete-requests",
        component: AccountDeleteRequestsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/account-delete-requests/:id",
        name: "account-delete-requests-detail",
        component: AccountDeleteRequestIdPage,
        meta: { requiresAuth: true }
      },

      // Doctor-specific pages
      {
        path: "/doctors/:doctorId/appointments",
        name: "DoctorAppointmentsPage",
        component: AppointmentsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctors/:doctorId/consultations",
        name: "DoctorConsultationsPage",
        component: ConsultationsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctors/:doctorId/prescriptions",
        name: "DoctorPrescriptionsPage",
        component: PrescriptionsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctors/:doctorId/transactions",
        name: "DoctorTransactionsPage",
        component: TransactionsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctors/:doctorId/bank-details",
        name: "DoctorBankDetailsPage",
        component: BankDetailsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctors/:doctorId/education-details",
        name: "DoctorEducationDetailsPage",
        component: EducationDetailsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctors/:doctorId/education-details/create",
        name: "DoctorEducationDetailCreatePage",
        component: EducationDetailCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctors/:doctorId/council-certificates",
        name: "DoctorCouncilCertificatesPage",
        component: CouncilRegistrationCertificatesPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctors/:doctorId/details",
        name: "DoctorDetailPage",
        component: DoctorDetailPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctors/:doctorId/council-certificates/create",
        name: "DoctorCouncilCertificateCreatePage",
        component: CouncilRegistrationCertificateCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctors/:doctorId/bank-details/create",
        name: "DoctorBankDetailCreatePage",
        component: BankDetailCreatePage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctors/:doctorId/documents",
        name: "DoctorDocumentsPage",
        component: UserDocumentsPage,
        meta: { requiresAuth: true }
      },
      {
        path: "/doctors/:doctorId/documents/create",
        name: "DoctorDocumentCreatePage",
        component: UserDocumentCreatePage,
        meta: { requiresAuth: true }
      },
    ],
  },
  // End AuthLayout

  // UnAuthLayout
  {
    path: "/unauth",
    name: "UnAuthLayout",
    component: UnAuthLayout,
    children: [
      {
        path: "/login",
        name: "LoginPage",
        component: (resolve) => {
          // Check if this is a seller subdomain
          const hostname = window.location.hostname;
          const isSellerSubdomain = hostname.startsWith('seller.');
          
          if (isSellerSubdomain) {
            resolve(SellerLoginPage);
          } else {
            resolve(LoginPage);
          }
        },
      },
      {
        path: "/seller-login",
        name: "SellerLoginPage",
        component: SellerLoginPage,
      },
      {
        path: "/forgot-password",
        name: "ForgotPasswordPage",
        component: ForgotPasswordPage,
      },
      {
        path: "/account-delete-request",
        name: "PublicAccountDeleteRequestPage",
        component: AccountDeleteRequestCreatePage,
      },
    ],
  },
  //End UnAuthLayout
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("=== Navigation Guard Debug ===");
  console.log("To Route Name:", to.name);
  console.log("To Route Path:", to.path);
  console.log("To Route Meta:", JSON.stringify(to.meta));
  console.log("Has allowPublic?", to.meta && to.meta.allowPublic);
  console.log("Authenticated:", store.getters["auth/authenticated"]);

  const authenticated = store.getters["auth/authenticated"];
  const isAdmin = store.getters["auth/isAdmin"];
  const isSuperAdmin = store.getters["auth/isSuperAdmin"];
  const permissions = store.getters["auth/permissions"];
  const user = store.getters["auth/user"];
  const isGuest = user && user.is_guest === true;

  // Check if this is seller subdomain
  const hostname = window.location.hostname;
  const isSellerSubdomain = hostname.startsWith('seller.');

  // FIRST: Allow access to public routes (accessible for both auth and unauth)
  // This check should come BEFORE auth checks
  if (to.meta && to.meta.allowPublic === true) {
    console.log("✅✅✅ Branch 0: Public route - ALLOWING ACCESS");
    return next();
  }

  console.log("⚠️ Not a public route, continuing to auth checks...");

  // Domain-based login page enforcement
  // seller.healthytantra.com should only show /seller-login
  // admin.healthytantra.com should only show /login
  if (isSellerSubdomain && to.path === '/login') {
    console.log("Branch: Seller domain accessing /login, redirecting to /seller-login");
    return next({ path: "/seller-login" });
  }
  if (hostname === 'admin.healthytantra.com' && to.path === '/seller-login') {
    console.log("Branch: Admin domain accessing /seller-login, redirecting to /login");
    return next({ path: "/login" });
  }

  // SECOND: Allow access to auth pages
  if (
    to.name === "LoginPage" ||
    to.name === "SellerLoginPage" ||
    to.name === "RegisterPage" ||
    to.name === "ForgotPasswordPage" ||
    to.name === "PublicAccountDeleteRequestPage"
  ) {
    console.log("Branch 1: Auth page accessed");
    if (authenticated) {
      console.log("Branch 1a: Already authenticated, redirecting to appropriate home");
      // Redirect to appropriate home based on subdomain
      if (isSellerSubdomain) {
        return next({ path: "/seller-home" });
      } else {
        return next({ name: "HomePage" });
      }
    }
    console.log("Branch 1b: Not authenticated, allowing access to auth page");
    return next();
  }

  // THIRD: Require authentication for protected routes
  if (!authenticated) {
    console.log("Branch 2: Not authenticated, redirecting to login");
    if (isSellerSubdomain) {
      return next({ path: "/seller-login" });
    }
    return next({ name: "LoginPage" });
  }

  // Handle null route names
  if (to.name === null) {
    console.log("Branch 3: Route name is null, redirecting to home");
    if (isSellerSubdomain) {
      return next({ path: "/seller-home" });
    }
    return next({ name: "HomePage" });
  }

  // Permission-based route protection
  if (to.meta && to.meta.permission) {
    const requiredPermission = to.meta.permission;
    
    // Admin and Super Admin have all permissions
    if (isAdmin || isSuperAdmin) {
      console.log("Branch 4a: Admin access granted");
      return next();
    }

    // Guest users have limited permissions
    if (isGuest) {
      const guestAllowedPermissions = [
        'PRODUCTS.VIEW',
        'PRODUCTS.SINGLE_VIEW',
        'PROFILE.VIEW'
      ];
      
      if (!guestAllowedPermissions.includes(requiredPermission)) {
        console.log("Branch 4b: Guest access denied for", requiredPermission);
        return next({ name: "HomePage" });
      }
    }
    
    // Check if user has required permission
    const hasPermission = permissions && permissions.includes(requiredPermission);
    
    if (!hasPermission) {
      console.log("Branch 4c: Permission denied for", requiredPermission);
      return next({ name: "HomePage" });
    }
  }

  // Check alternative permissions if specified (for routes that accept multiple permissions)
  if (to.meta && to.meta.permissions && !isAdmin && !isSuperAdmin) {
    const hasAnyPermission = to.meta.permissions.some(permission => {
      if (isGuest) {
        const guestAllowedPermissions = [
          'PRODUCTS.VIEW',
          'PRODUCTS.SINGLE_VIEW',
          'PROFILE.VIEW'
        ];
        return guestAllowedPermissions.includes(permission);
      }
      return permissions && permissions.includes(permission);
    });
    
    if (!hasAnyPermission) {
      console.log("Branch 5: No alternative permissions found");
      return next({ name: "HomePage" });
    }
  }

  console.log("Branch 6: Allowing navigation");
  next();
});


export default router;
